import type { AddToCartButton } from "./types/types";

export const createAddToCartButton = (): AddToCartButton => {
  return {
    event: "Webshop Add to Cart Button",
  };
};
